import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/workspace.css';
import './styles/ui-repair.css';
import './styles/login-fix.css';
import './styles/audit-filter-fix.css';
// R14: визуальный refresh — фиолетовый brand, мягче shadows/transitions.
// Подключается ПОСЛЕДНИМ чтобы перебивать существующие правила.
import './styles/brand-refresh.css';
import './styles/layout-polish.css';
import './styles/system-polish.css';
import './styles/analytics.css';
import './styles/local-ai.css';
import './styles/unified-workspace.css';
import './styles/modern-minimal.css';
import App from './App';
import { getUiLocale } from './i18n/uiText';
import { ToastProvider } from './store/ToastContext';
import { ConfirmProvider } from './store/ConfirmContext';
import UiEnhancer from './components/common/UiEnhancer';
import './styles/final-polish.css';
import './styles/visual-hierarchy.css';
import './styles/product-ux.css';
import './styles/premium-minimal.css';
import './styles/review-fixes.css';
import './styles/template-picker.css';
import './styles/dark-theme.css';
import './styles/mobile-compat.css';
import './styles/components.css';
import './styles/evidence.css';
import './styles/studio.css';

try {
  const initialTheme = localStorage.getItem('audit_pro_theme') === 'dark' ? 'dark' : 'light';
  document.documentElement.dataset.theme = initialTheme;
  document.documentElement.style.colorScheme = initialTheme;
  document.body.dataset.theme = initialTheme;
} catch {
  document.documentElement.dataset.theme = 'light';
}

document.documentElement.lang = getUiLocale();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ToastProvider>
      <ConfirmProvider>
        <UiEnhancer />
        <App />
      </ConfirmProvider>
    </ToastProvider>
  </React.StrictMode>
);
